import * as Yup from "yup";
const phoneRegExp = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/;

export const orderValidationSchema = Yup.object().shape({
  phone: Yup.string().required("Обязательное поле *").matches(phoneRegExp, "Некорректный номер *"),
  userName: Yup.string().required("Обязательное поле *"),
  city: Yup.string().required("Обязательное поле *"),
  email: Yup.string().required("Поле обязательно *").email("Некорректный Email *"),
});
